export const getDisplayFileName = (file = {}) => {
  if (!file) return "";

  // 1. Prefer original name if exists
  if (file.originalName) {
    return String(file.originalName).trim();
  }

  let name = String(file.fileName || "").trim();
  if (!name) return "";

  // 2. Remove "scan-" prefix if present
  if (name.startsWith("scan-")) {
    name = name.slice(5);
  }

  // 3. Remove numeric prefixes like:
  // 1777982226907-524031-
  // or 1777982226907-
  name = name.replace(/^\d+-\d+-/, ""); // timestamp-random-
  name = name.replace(/^\d+-/, "");     // fallback: timestamp-

  // 4. Clean accidental double dashes or spaces
  name = name.replace(/--+/g, "-").replace(/\s+/g, " ").trim();

  // 5. OPTIONAL: shorten very long names (UI polish)
  const MAX_LENGTH = 60;
  if (name.length > MAX_LENGTH) {
    const ext = name.includes(".") ? "." + name.split(".").pop() : "";
    const base = name.replace(ext, "");
    return base.slice(0, MAX_LENGTH - ext.length - 3) + "..." + ext;
  }

  return name;
};